/* "Email this selection" - wholesale notes page only.

   A third action alongside Save my notes and Submit order request. It sends the buyer (and the
   office) a visual copy of the WORKING selection as it stands: a PDF with the shoe photos,
   swatches and whatever size runs are set so far, plus a link back to these live notes. It is
   explicitly not an order: nothing is submitted, no prices are frozen, nothing leaves Notes, and
   it can be sent as many times as the conversation needs (chasing a buyer to finalise is exactly
   the use case).

   Deliberately a separate file that injects itself, rather than an edit to wholesale-cart.js:
   the cart engine is long and this action shares none of its state. It only needs the client id,
   which the shared API layer already resolves. */
(function () {
  var root = document.querySelector('[data-ws-cart]');
  if (!root) return;

  function inject() {
    var row = root.querySelector('.ws-submit-row');
    if (!row || row.querySelector('[data-ws-email-notes]')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button ws-submit ws-submit--notes';
    btn.setAttribute('data-ws-email-notes', '');
    btn.textContent = 'Email this selection';
    row.appendChild(btn);

    var msgEl = root.querySelector('[data-ws-msg]');
    function say(text, kind) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.className = 'ws-submit__msg' + (kind ? ' ws-status--' + kind : '');
    }

    btn.addEventListener('click', function () {
      var api = window.WSApi;
      if (!api) return;
      btn.disabled = true;
      say('Sending...', '');
      api.call('emailSelection', api.identity({ client_id: (api.ctx && api.ctx.client_id) || '' }))
        .then(function (resp) {
          btn.disabled = false;
          if (resp && resp.ok && resp.data) {
            var to = (resp.data.emailed_to || []).join(', ');
            say('Sent' + (to ? ' to ' + to : '') + '. That was a copy of the selection, not an order.', 'ok');
          } else {
            say((resp && resp.error) ? resp.error : 'Could not send the selection. Please try again.', 'warn');
          }
        })
        .catch(function () {
          btn.disabled = false;
          say('Could not send the selection. Please try again.', 'warn');
        });
    });
  }

  /* The footer stays hidden until the cart engine has drawn the lines, so watch for it
     rather than injecting into a footer that does not exist yet. */
  function start() {
    inject();
    if (window.MutationObserver) {
      new MutationObserver(inject).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
